import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";

const KEY = "chronos.consent.v1";

export default function ConsentBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(KEY);
      if (!stored) setVisible(true);
    } catch (e) { /* ignore */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() })); } catch (e) {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-4 left-4 right-4 z-[80] max-w-3xl mx-auto"
          data-testid="consent-banner"
        >
          <div className="glass-strong rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-3 shadow-2xl border-emerald-400/40 border">
            <ShieldCheck className="w-6 h-6 text-emerald-300 shrink-0" />
            <div className="flex-1 text-sm text-stone-200">
              {t("consent.text")}{" "}
              <Link to="/privacy" className="text-amber-300 hover:text-amber-200 underline" data-testid="consent-privacy-link">
                {t("consent.privacy")}
              </Link>
            </div>
            <button
              onClick={accept}
              className="bg-emerald-500 hover:bg-emerald-400 text-stone-950 font-bold rounded-full px-5 py-2 text-sm w-full sm:w-auto"
              data-testid="consent-accept"
            >
              {t("consent.accept")}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
